<app-gallery-settings-customize-header
  title="Color Labels"
  location="color-labels-setting-customize"
  (back)="back.emit()"
></app-gallery-settings-customize-header>

<app-gallery-settings-group
  title="Customize Labels"
  location="color-labels-setting-customize"
  scope="asset:custom-labels"
>
  @for (color of colors(); track color.color) {
    <app-custom-color-labels-setting-item
      [gallery]="gallery()"
      [colorLabel]="color"
    ></app-custom-color-labels-setting-item>
  }
</app-gallery-settings-group>
